import { ManzanitaPresetListResponse } from "../../../common/api/orders-api/manzanita-preset/responses/GetManzanitaPresetsListResponse";

export interface ManzanitaPresetListingItem {
    id: string;
    name: string;
    filePath: string;
    updatedDate: string;
}

export const mapToManzanitaPresetListingItem = (
    manzanitaPreset: ManzanitaPresetListResponse
): ManzanitaPresetListingItem => {
    return {
        id: manzanitaPreset.id,
        name: manzanitaPreset.name,
        filePath: manzanitaPreset.filePath,
        updatedDate: manzanitaPreset.updatedDate
    };
};
